export type ViewerSplitPanePercent = number & {
	readonly __brand: "ViewerSplitPanePercent";
};

export const VIEWER_SPLIT_PANE_MIN_PERCENT = 10;
export const VIEWER_SPLIT_PANE_MAX_PERCENT = 90;

export const tryCreateViewerSplitPanePercent = (
	value: number,
): ViewerSplitPanePercent | null => {
	if (!Number.isFinite(value)) {
		return null;
	}
	if (value < VIEWER_SPLIT_PANE_MIN_PERCENT) {
		return null;
	}
	if (value > VIEWER_SPLIT_PANE_MAX_PERCENT) {
		return null;
	}
	return value as ViewerSplitPanePercent;
};

export const createViewerSplitPanePercent = (
	value: number,
): ViewerSplitPanePercent => {
	const result = tryCreateViewerSplitPanePercent(value);
	if (result === null) {
		throw new Error(
			`Invalid ViewerSplitPanePercent: ${String(value)} (expected ${VIEWER_SPLIT_PANE_MIN_PERCENT}-${VIEWER_SPLIT_PANE_MAX_PERCENT})`,
		);
	}
	return result;
};

export const DEFAULT_VIEWER_SPLIT_PANE_PERCENT =
	createViewerSplitPanePercent(30);
